<template lang="pug">
v-container
  h1 Ошибки пользователя
  v-list(v-if="!loading")
    v-list-item(outlined)
      v-list-item-content
        v-list-item-title: strong {{ data.email }}
        v-list-item-subtitle Статус
          v-chip.ml-2(small :color="data.status ? 'success' : 'error' ") {{ data.status ? 'ok' : 'Ошибки' }}
    v-divider.mb-4
    v-list-item(v-for="(item, idx) in data.error")
      v-list-item-avatar(size="32" color="primary").white--text: strong {{ idx+1 }}
      v-list-item-title {{ item }}
    v-alert(v-if="!data.error.length" type="info") Ошибок нет
</template>
<script>

import service from '@/services/API/letter-handler';

export default {
  data() {
    return {
      data: {},
      loading: true,
    };
  },
  created() {
    this.getUserErrors();
  },
  methods: {
    async getUserErrors() {
      const { data } =  await service.getNodeStatus({ 'search[user_id]': this.$route.params.id });
      [this.data] = data.data;
      this.loading = false;
    },
  },
};
</script>
